export default {
    event: {},
    base: {},
    currentEvent: {},
    events: [],
    organizationEventList: [],
    eventAttendees: {
        id: "",
        name: "",
        attendeeWithPassword: false,
        orders: []
    },
    eventAttendeesTransactions: {
        id: "",
        name: "",
        orders: []
    },
    filter: {
        name: "",
        category: "",
        subcategory: "Todos",
        modality: "Todas",
    },
    ticketsOutOfStock: true,
};